// extracted by mini-css-extract-plugin
module.exports = {"searchHeaderSection":"_1Rc5W"};